var render, staticRenderFns
import script from "./Moderation.vue?vue&type=script&lang=js"
export * from "./Moderation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f61df3fa')) {
      api.createRecord('f61df3fa', component.options)
    } else {
      api.reload('f61df3fa', component.options)
    }
    
  }
}
component.options.__file = "src/components/mixins/Moderation.vue"
export default component.exports